import { svg } from 'lit';
export const bell24Svg = svg `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18 7.5C18 5.9087 17.3679 4.38258 16.2426 3.25736C15.1174 2.13214 13.5913 1.5 12 1.5C10.4087 1.5 8.88258 2.13214 7.75736 3.25736C6.63214 4.38258 6 5.9087 6 7.5C6 14.5 3 16.5 3 16.5H21C21 16.5 18 14.5 18 7.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.5 21C13.3476 21.2628 13.1288 21.4809 12.8655 21.6325C12.6023 21.7842 12.3038 21.864 12 21.864C11.6962 21.864 11.3977 21.7842 11.1345 21.6325C10.8712 21.4809 10.6524 21.2628 10.5 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
//# sourceMappingURL=bell_24.svg.js.map